import moment from "moment";
import Locale from "@/helper/locale/locale.js";

export default {
    /********* Datetime *********
     * @function convertDateToTimeStampUnix
     * @function isDatetimeValid
     * @function cleanTimeFormDatetime
     ****************************/
    convertDateToTimeStampUnix: function(date) {
        var unixTime = (date.getTime() - date.getTimezoneOffset() * 60 * 1000) / 1000;
        return unixTime;
    },
    isDatetimeValid: function(y, m, d) {
        var year = y;
        var month = m < 10 ? '0' + m : m;
        var day = d < 10 ? '0' + d : d;
        var dateFormat = year + '-' + month + '-' + day;

        return moment(dateFormat).isValid();
    },
    cleanTimeFormDatetime: function(datetime) {
        var date = new Date(datetime.getFullYear(), datetime.getMonth(), datetime.getDate());
        return date;
    },

    /********** Date Format ***********
     * @function dateFullFormat
     * @function getYearByLocale
     * @function timeFormat
     **********************************/
    dateFullFormat: function(timestamp) {
        if (Locale.getLocaleCode() == 1033) {
            moment.locale('en');
        } else {
            moment.locale('th');
        }
        var strDate = moment.unix(timestamp).utc().format('DD MMMM ');
        var year = moment.unix(timestamp).utc().format('YYYY');
        year = this.getYearByLocale(year);

        return strDate + year;
    },
    getYearByLocale: function(year) {
        if (Locale.getLocaleCode() == 1033) {
            return year;
        }
        return parseInt(year) + 543;
    },
    timeFormat: function(timestamp) {
        var strDate = moment.unix(timestamp).utc().format('HH:mm:ss');
        return strDate;
    },
    // date range format
    dateRangeFormat: function(startTimestamp, endTimestamp, monthArray, localeCode, options) {
        // Validate inputs
        if (!startTimestamp || !endTimestamp || !monthArray) {
            return '';
        }

        // Validate that startDate <= endDate
        if (startTimestamp > endTimestamp) {
            return '';
        }

        // Set default options
        options = options || {};
        var useShortYear = options.useShortYear || false;

        var startMoment = moment.unix(startTimestamp).utc();
        var endMoment = moment.unix(endTimestamp).utc();

        // Get date components
        var startDay = startMoment.format('DD');
        var startMonth = parseInt(startMoment.format('M')) - 1; // 0-based index
        var startYear = parseInt(startMoment.format('YYYY'));
        
        var endDay = endMoment.format('DD');
        var endMonth = parseInt(endMoment.format('M')) - 1; // 0-based index
        var endYear = parseInt(endMoment.format('YYYY'));

        // Convert year for Thai locale
        if (localeCode === 1054) {
            startYear = startYear + 543;
            endYear = endYear + 543;
        }

        // Format year (short or full)
        var formatYear = function(year) {
            if (useShortYear) {
                return year.toString().substring(2, 4); // Last 2 digits
            }
            return year.toString();
        };

        var startYearStr = formatYear(startYear);
        var endYearStr = formatYear(endYear);
        var startMonthName = monthArray[startMonth] || '';
        var endMonthName = monthArray[endMonth] || '';

        // Case 1: Same day
        if (startDay === endDay && startMonth === endMonth && startYear === endYear) {
            return `${startDay} ${startMonthName} ${startYearStr}`;
        }

        // Case 2: Same month, same year
        if (startMonth === endMonth && startYear === endYear) {
            return `${startDay} - ${endDay} ${startMonthName} ${startYearStr}`;
        }

        // Case 3: Different month, same year
        if (startYear === endYear) {
            return `${startDay} ${startMonthName} - ${endDay} ${endMonthName} ${startYearStr}`;
        }

        // Case 4: Different month, different year
        return `${startDay} ${startMonthName} ${startYearStr} - ${endDay} ${endMonthName} ${endYearStr}`;
    },
}
